import { useEffect } from 'react';

export default function(form, errors, isSubmitSuccess, submitting) {
  useEffect(() => {
    if ((!errors || isSubmitSuccess) && !submitting) {
      form.reset();
    }
  }, [errors, isSubmitSuccess, submitting]);
}
